export const LANDING_HERO_SECTION_ID = 'hero';

export const LANDING_SECTION_PATHS = {
  '/how-it-works': 'how-it-works',
  '/features': 'features',
  '/pricing': 'pricing',
  '/faq': 'faq',
} as const;

export type LandingSectionPath = keyof typeof LANDING_SECTION_PATHS;

export function landingPathToSectionId(path: string): string | null {
  return LANDING_SECTION_PATHS[path as LandingSectionPath] ?? null;
}

function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function scrollToLandingSection(sectionId: string): void {
  const target = document.getElementById(sectionId);
  if (!target) return;
  target.scrollIntoView({
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    block: 'start',
  });
}
